import { render } from "./DemoBasic.vue?vue&type=template&id=187cec32&scoped=true&ts=true"
import script from "./DemoBasic.vue?vue&type=script&lang=ts"
export * from "./DemoBasic.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187cec32"]])

export default __exports__